import Vue from 'vue';
import App from './app.vue';
import ReactDOM from 'react-dom';
import React from 'react';
import '@/component/button';
import Header from '@/component/header';
import Footer from '@/component/footer';

new Vue({
    render: h => h(App)
}).$mount('#chj-content');

ReactDOM.render(<Header />, document.getElementById('chj-header'));

ReactDOM.render(<Footer />, document.getElementById('chj-footer'));
